import api from './api';

async function getVacancyByIdForUrlAPI(vacancyIdForUrl: string) {
  const response = await api.get(
    `vacancy/id/${vacancyIdForUrl}/`,
  );
  return response?.data;
}

export default getVacancyByIdForUrlAPI;
